import { domain_vizr } from "../../redux/constants/constants";

export const RISK_CATEGORIES = [
  {
    id: "public-sensitive",
    title: "Sensitive Files Publicly Shared",
    icon: "ti-world-share",
    priority: "Critical",
    severity: "red",
    summary: "Files with sensitive data exposed via public links",
    image:
      "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=1000&q=80",
    subjectLabel: "File",
    metricLabel: "Downloads flagged",
    metricUnit: "Files",
    items: [
      {
        id: "ACT-001",
        timestamp: "2025-07-01 09:42",
        subject: "employee_records_2025.xlsx",
        subjectMeta: "PII · spreadsheet",
        source: "Google Drive",
        scope: "File-level",
        severity: "Critical",
        metric: 10,
        reason:
          "Downloaded 10 times in the last 48 hours and currently shared via a public link.",
        actions: ["Remove public access", "Restrict sharing"],
      },
      {
        id: "ACT-002",
        timestamp: "2025-06-30 14:10",
        subject: "payment_log_april.csv",
        subjectMeta: "PCI · spreadsheet",
        source: "Google Drive",
        scope: "File-level",
        severity: "High",
        metric: 6,
        reason:
          "Shared via a public link and downloaded 6 times in the last 24 hours.",
        actions: ["Remove public access", "Restrict sharing"],
      },
    ],
  },
  {
    id: "user-risk",
    title: "Restrict Files of a User",
    priority: "High",
    icon: "ti-user-exclamation",
    severity: "red",
    summary: "Users with unusual sharing or access patterns",
    image:
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1000&q=80",
    subjectLabel: "User",
    metricLabel: "Files exposed",
    metricUnit: "users exposed",
    items: [
      {
        id: "ACT-003",
        timestamp: "2025-06-29 11:22",
        subject: "lynne robbins",
        subjectMeta: "odtest · team-drive",
        source: "Team Drive",
        scope: "Account-level",
        severity: "Medium",
        metric: 8,
        reason:
          "8 public files shared, and access detected from 3 locations within the same hour.",
        actions: ["Restrict file access", "Require re-verification"],
      },
      {
        id: "ACT-004",
        timestamp: "2025-06-27 09:03",
        subject: "Ben Goe",
        subjectMeta: "googledrive · shared",
        source: "Google Drive",
        scope: "Account-level",
        severity: "High",
        metric: 2,
        reason:
          "Shared 2 large files (>500MB) containing confidential data with external recipients.",
        actions: ["Restrict file access"],
      },
    ],
  },
  {
    id: "org-wide",
    title: "Restrict Organization Files",
    priority: "Low",
    icon: "ti-building-warehouse",
    severity: "red",
    summary: "Org-wide activity surge detected",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1000&q=80",
    subjectLabel: "Scope",
    metricLabel: "Downloads detected",
    metricUnit: "Scopes",
    items: [
      {
        id: "ACT-005",
        timestamp: "2025-06-25 16:47",
        subject: "Organization-wide",
        subjectMeta: "18 users involved",
        source: "Multiple sources",
        scope: "Org-wide",
        severity: "High",
        metric: 142,
        reason:
          "142 downloads across 18 users within a 6-minute window — far above the normal baseline.",
        actions: ["Restrict org-wide downloads", "Notify security team"],
      },
    ],
  },
  {
    id: "location",
    title: "Restrict User — Unusual Location",
    priority: "High",
    icon: "ti-map-pin-off",
    severity: "amber",
    summary: "Logins from unexpected or conflicting locations",
    image:
      "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1000&q=80",
    subjectLabel: "User",
    metricLabel: "Countries flagged",
    metricUnit: "Locations",
    items: [
      {
        id: "ACT-006",
        timestamp: "2025-06-24 08:14",
        subject: "khushi agarwal",
        subjectMeta: "odtest · reports",
        source: "OneDrive",
        scope: "Account-level",
        severity: "High",
        metric: 3,
        reason: "Logged in from 3 different countries within a 2-hour window.",
        actions: ["Restrict access org-wide", "Force MFA re-auth"],
      },
      {
        id: "ACT-007",
        timestamp: "2025-06-22 19:58",
        subject: "john.doe",
        subjectMeta: "googledrive",
        source: "Google Drive",
        scope: "Account-level",
        severity: "Medium",
        metric: 1,
        reason:
          "Login detected from a new country with no prior travel history on file.",
        actions: ["Restrict access org-wide"],
      },
    ],
  },
];

export const SEVERITY_TONE = {
  Critical: "red",
  High: "red",
  Medium: "amber",
  Low: "blue",
};

export const CASE_SEVERITY_TONE = {
  CRITICAL: "red",
  HIGH: "red",
  MEDIUM: "amber",
  LOW: "blue",
};

export const SEVERITY_RANK = { Critical: 4, High: 3, Medium: 2, Low: 1 };

export function actionKey(categoryId, subject) {
  return `${categoryId}::${subject}`;
}

export const GET_DATA_CONTROL_CARD_SUMMARY = "GET_DATA_CONTROL_CARD_SUMMARY";
export const GET_DATA_CONTROL_DASHBOARD_SUMMARY = "GET_DATA_CONTROL_DASHBOARD_SUMMARY";
export const getDataControlCardSummaryAPI = () => {
    return `${domain_vizr}/nlp/cardSummary`
}
export const getDataControlDashboardSummaryAPI = () => {
  return `${domain_vizr}/nlp/summary`
}
export const SET_DATA_CONTROL_DASHBOARD_SUMMARY = "SET_DATA_CONTROL_DASHBOARD_SUMMARY";
export const SET_DATA_CONTROL_CARD_SUMMARY = "SET_DATA_CONTROL_CARD_SUMMARY";
export const SET_DATA_CONTROL_LOADER = "SET_DATA_CONTROL_LOADER";

export const CARD_NAMES = [
  "Sensitive Files Publicly Shared",
  "Restrict Files of a User",
  "Restrict Organization Files",
  "Restrict User — Unusual Location",
];

export const fileInfoAPI = () => {
  return `${domain_vizr}/tenant/dataControl/fileInfo?actionFrom=dataControl`
}
export const FETCH_DATA_CONTROL_FILES_DATA = "FETCH_DATA_CONTROL_FILES_DATA";
export const SET_DATA_CONTROL_FILES_DATA = "SET_DATA_CONTROL_FILES_DATA";

export const removePublicAccessAPI = (dataSourceId) => {
  return `${domain_vizr}/tenant/publicDataAsset/dataSource/${dataSourceId}/revokeAccess/files?actionFrom=dataControl`
}
export const removeUserAccessAPI = (dataSourceId, enterpriseActorId) => {
  return `${domain_vizr}/tenant/publicDataAsset/${dataSourceId}/revokeAccess/actor/${enterpriseActorId}?actionFrom=dataControl
`
}

export const revokeDomainWideAccessAPI = (dataSourceId) => {
  return `${domain_vizr}/tenant/publicDataAsset/${dataSourceId}/revokeAccess/domainWide?actionFrom=dataControl`
}
export const revokeUserLocationAccessAPI = (dataSourceId, enterpriseActorId) => {
  return `${domain_vizr}/tenant/dataControl/changeStatus`
}
export const SET_REVOKE_FILE_IDS = "SET_REVOKE_FILE_IDS";
export const REVOKE_FILE_ACCESS = "REVOKE_FILE_ACCESS";

export const getFileAuditTrail = () => {
  return `${domain_vizr}/tenant/publicDataAsset/auditTrail?actionFrom=dataControl&actionType=FILE`
}

export const getUserAuditTrail = () => {
  return `${domain_vizr}/tenant/publicDataAsset/auditTrail?actionFrom=dataControl&actionType=ACTOR`
}

export const getDomainAuditTrailAPI = () => {
  return `${domain_vizr}/tenant/publicDataAsset/auditTrail?actionFrom=dataControl&actionType=DOMAIN`
}

export const SET_FILE_AUDIT_TRAIL = "SET_FILE_AUDIT_TRAIL";
export const GET_FILE_AUDIT_TRAIL = "GET_FILE_AUDIT_TRAIL";
export const SET_DOMAIN_AUDIT_TRAILS = "SET_DOMAIN_AUDIT_TRAILS";

export const userInfoAPI = () => {
  return `${domain_vizr}/tenant/dataControl/userFilesView?actionFrom=dataControl`
}
export const GET_DATA_CONTROL_USER_FILES_VIEW = "GET_DATA_CONTROL_USER_FILES_VIEW";
export const SET_DATA_CONTROL_USER_FILES_VIEW = "SET_DATA_CONTROL_USER_FILES_VIEW";
export const SET_USER_AUDIT_TRAILS = "SET_USER_AUDIT_TRAILS";
export const GET_USER_AUDIT_TRAILS = "GET_USER_AUDIT_TRAILS";
export const GET_DOMAIN_AUDIT_TRAILS = "GET_DOMAIN_AUDIT_TRAILS";

export const domainInfoAPI = () => {
  return `${domain_vizr}/tenant/dataControl/organizationFilesView?actionFrom=dataControl`
}
export const GET_DATA_CONTROL_DOMAIN_FILES_VIEW = "GET_DATA_CONTROL_DOMAIN_FILES_VIEW";
export const SET_DATA_CONTROL_DOMAIN_FILES_VIEW = "SET_DATA_CONTROL_DOMAIN_FILES_VIEW";
export const DATA_CONTROL_SNACKBAR = "DATA_CONTROL_SNACKBAR";

export const userLocationInfoAPI = () => {
  return `${domain_vizr}/tenant/dataControl/disableUserView?actionFrom=dataControl`
}
export const GET_USER_LOCATION_AUDIT_TRAIL = "GET_USER_LOCATION_AUDIT_TRAIL";
export const SET_USER_LOCATION_AUDIT_TRAIL = "SET_USER_LOCATION_AUDIT_TRAIL";
export const fetchUserLocationAuditTrail = () => {
  return `${domain_vizr}/tenant/publicDataAsset/auditTrail?actionFrom=dataControl&actionType=DISABLE_USER`
}
export const GET_USER_LOCATION_DATA = "GET_USER_LOCATION_DATA";
export const GET_USER_LOCATION_AUDIT_TRAILS = "GET_USER_LOCATION_AUDIT_TRAILS";